<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/forecastManagement/overseasShelve";
export default {
  name: "overseasShelve",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {
        files: {
          config: {
            title: this.$tz("异常,文件"),
            modalBind: {
              width: 800
            }
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 600,
              resize: false
            },
            fields: [
              {
                name: () => this.$t("fileName"),
                key: "name",
                minWidth: 150
              },
              {
                width: 100,
                name: () => this.$t("operation"),
                fixed: "right",
                key: "operation",
                type: "btns",
                list: [
                  {
                    name: () => this.$t("show"),
                    type: "src",
                    fnName: "previewFun",
                    disabled: ({ row }) => !row.src,
                    bind: {
                      type: "primary"
                    }
                  }
                ],
                methods: {
                  previewFun({ row, field }) {
                    this.openUrl(row.src);
                  }
                }
              }
            ]
          }
        },
        reply: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });

              this.$page
                .handleRequestMethods("deal", data, true, true)
                .then(res => {
                  this.$page.getList();
                  this.$page
                    .handleRequestMethods(
                      "exception",
                      { id: this.$page.getModal("detail").params.id },
                      false,
                      true
                    )
                    .then(res => {
                      this.$page.getModal("detail").list = res.payload;
                    });
                  close();
                });
            }
          },
          config: {
            title: this.$tz("回复"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              scheme: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ scheme: 24 }],
          fields: [
            {
              key: "scheme",
              name: () => this.$tz("回复"),
              placeholder() {
                return this.$tz("回复");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 4 }
              }
            }
          ]
        },
        detail: {
          config: {
            title: this.$tz("异常,记录"),
            modalBind: {
              width: 1000
            }
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$tz("异常,类型"),
                key: "type",
                minWidth: 130
              },
              {
                name: () => this.$tz("异常,备注"),
                key: "remarks",
                minWidth: 130
              },
              {
                name: () => this.$tz("添加人"),
                key: "create_name",
                minWidth: 130
              },
              {
                name: () => this.$tz("添加,时间"),
                key: "create_time",
                minWidth: 130
              },
              {
                name: () => this.$tz("客服,方案"),
                key: "scheme",
                minWidth: 130
              },
              {
                name: () => this.$tz("跟进,客服"),
                key: "service_name",
                minWidth: 130
              },
              {
                name: () => this.$tz("方案,时间"),
                key: "scheme_time",
                minWidth: 130
              },
              {
                name: () => this.$t("operation"),
                type: "btns",
                width: 220,
                fixed: "right",
                list: [
                  {
                    name: this.$tz("回复"),
                    type: "reply",
                    fnName: "reply",
                    bind: {
                      type: "primary"
                    },
                    id: ""
                  },
                  {
                    name: () => this.$tz("异常,文件"),
                    type: "files",
                    fnName: "files",
                    bind: {
                      type: "primary"
                    }
                  }
                ],
                methods: {
                  files({ row }) {
                    this.getModal("files").open(null, function() {
                      this.setTitle(this.$tz("异常,文件"));
                      this.list = row.src;
                    });
                  },
                  reply({ row }) {
                    this.getModal("reply").open(row, function() {
                      this.setTitle(this.$tz("回复"));
                    });
                  }
                }
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "warehouse_id",
            placeholder() {
              return this.$tz("仓库");
            },
            component: "Select",
            options: [],
            optionsFn: "predictionWarehouse",
            apiData: { type: "is_shelf" },
            optionsKey: ""
          },
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户");
            },
            component: "Select",
            options: [],
            optionsFn: "customer",
            optionsKey: ""
          },
          {
            key: "service_id",
            placeholder() {
              return this.$tz("客服");
            },
            component: "Select",
            options: [],
            optionsFn: "service",
            optionsKey: "",
            apiData: [2]
          },
          {
            key: "status",
            placeholder() {
              return this.$tz("状态");
            },
            component: "Select",
            options: [],
            optionsFn: "towType",
            optionsKey: ""
          },
          {
            key: "abnormal_status",
            placeholder() {
              return this.$tz("异常,状态");
            },
            component: "Select",
            options: [],
            optionsFn: "abnormalStatus",
            optionsKey: ""
          },
          {
            name: this.$tz("平台"),
            key: "platform",
            component: "Select",
            placeholder: () => this.$tz("平台"),
            options: [],
            optionsFn: "platform",
            optionsKey: "",
            default: ""
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center"
        },
        {
          name: () => this.$tz("客户名称"),
          key: "client",
          minWidth: 130
        },
        {
          name: () => this.$tz("公司名称"),
          key: "company",
          minWidth: 130
        },
        {
          name: () => this.$tz("订单号"),
          key: "airway_number",
          minWidth: 140,
          header: {
            copy: true
          },
          copy: true
        },
        {
          name: () => this.$tz("箱数"),
          key: "number",
          minWidth: 130
        },
        {
          name: () => this.$tz("SKU数量"),
          key: "pcs",
          minWidth: 130
        },
        {
          name: () => this.$tz("订单,状态"),
          key: "status",
          minWidth: 130
        },
        {
          name: () => this.$tz("客服"),
          key: "service_name",
          minWidth: 130
        },
        {
          name: () => this.$tz("平台"),
          key: "platform",
          minWidth: 110
        },
        {
          name: () => this.$tz("起运国"),
          key: "from_country",
          minWidth: 130
        },
        {
          name: () => this.$tz("目的国"),
          key: "to_country",
          minWidth: 130
        },
        {
          name: () => this.$tz("仓库名称"),
          key: "warehouse",
          minWidth: 130
        },
        {
          name: () => this.$tz("运输方式"),
          key: "transport",
          minWidth: 130
        },
        {
          name: () => this.$tz("入仓,时间"),
          key: "c_time",
          minWidth: 110
        },
        {
          name: () => this.$tz("开始上架时间"),
          key: "operate_time",
          minWidth: 110
        },
        {
          name: () => this.$tz("上架完成时间"),
          key: "complete_time",
          minWidth: 110
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("异常,记录"),
              type: "detail",
              fnName: "detail",
              bind: {
                type: "primary"
              },
              id: ""
            }
          ],
          methods: {
            detail({ row }) {
              this.handleRequestMethods(
                "exception",
                { id: row.id },
                false,
                true
              ).then(res => {
                this.getModal("detail").open(row, function() {
                  this.list = res.payload;
                  this.setTitle(this.$tz("异常,记录"));
                });
              });
            }
          }
        }
      ]
    };
  }
};
</script>

<style scoped></style>
